import React from 'react';
import styles from './CardExpend.module.scss';
import cn from 'classnames';

const CardExpend = ({ value = '', label = '', className, ...props }) => {
  return (
    <div {...props} className={cn(className, styles.root)}>
      <div className={styles.label}>{label}</div>
      <div className={styles.content}>{value}</div>
    </div>
  );
};

export default CardExpend;
